import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

export default ({ env, store }, inject) => {
	// TODO: Think about better local environment detection
	const isLocal = window.location.hostname === 'localhost'
	const appReleaseStage = isLocal ? 'local' : env.CONFIG_ENV
	const isProd = ['staging', 'production'].includes(env.CONFIG_ENV)

	Bugsnag.start({
		appType: env.appType,
		appVersion: env.version,
		apiKey: env.bugsnagApiKey,
		releaseStage: appReleaseStage,
		enabledReleaseStages: ['development', 'staging', 'production'],
		autoTrackSessions: true,
		autoDetectErrors: true,
		plugins: [new BugsnagPluginVue()],
		enabledErrorTypes: {
			unhandledExceptions: true,
			unhandledRejections: true
		},
		logger: isProd ? null : undefined,
		onError: setEventMetadata
	})

	const $bugsnag = {
		notifyBreadcrumb (message, meta) {
			Bugsnag.leaveBreadcrumb(message, meta)
		},

		notify (error, callback) {
			Bugsnag.notify(error, (event) => {
				if (callback) {
					callback(event)
				}

				setEventMetadata(event)
			})
		}
	}

	inject('bugsnag', $bugsnag)

	function setEventMetadata (event) {
		const user = store.getters['user/user']
		const region = store.getters['user/region']

		event.addMetadata('region', region)

		if (user) {
			event.setUser(user.id, user.email, user.fullName)
			event.addMetadata('user', user)
		}
	}
}
